/**
 * @file コンポーネント：フル動画ページノートポップアップ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PopupNote = (props) => {
    /**
     * ポップアップコンテンツの高さ設定
     */
    const refPopupContent = useRef(null);
    useEffect(() => {
        if (refPopupContent.current) {
            refPopupContent.current.style.height =
                document.documentElement.clientHeight - 228 + "px";
        }
    }, [refPopupContent.current]);

    // Presenterに渡す
    return <Presenter {...props} refPopupContent={refPopupContent} />;
};
